/* ============================================================
   section-page-content-checkout-bb-assortment.js
   ============================================================ */

/* ------------------------------------------------------------------
   Shared state
   activeProductVariantId is set on page load from checkoutBundleVars
   and updated live by the multi-product toggle whenever the user
   switches between bundle options.
------------------------------------------------------------------ */
window.activeProductVariantId =
  window.checkoutBundleVars?.productVariantsFirstId ?? null;

/**
 * Returns the variant ID to add to cart.
 * When hasFlavourProducts is active, reads the selected pack pill
 * for the currently active flavor panel; otherwise falls back to the
 * classic toggle / static default.
 */
function getActiveVariantId() {
  /* Always check the DOM first — works whether or not hasFlavourProducts flag is set */
  const activePack = document.querySelector("#fp-pack-panels-container .fp-pack-option.is-active");
  if (activePack?.dataset?.variantId) return activePack.dataset.variantId;

  return (
    window.activeProductVariantId ||
    window.checkoutBundleVars?.productVariantsFirstId
  );
}

/**
 * Returns the selling plan ID for the currently active pack pill,
 * falling back to the section-level selling plan from checkoutBundleVars.
 */
function getActiveSellingPlan() {
  const activePack = document.querySelector("#fp-pack-panels-container .fp-pack-option.is-active");
  if (activePack?.dataset?.sellingPlan) return activePack.dataset.sellingPlan;
  return window.checkoutBundleVars?.sellingPlan;
}

/* ------------------------------------------------------------------
   Scroll-to-purchase CTA buttons (header / hero)
------------------------------------------------------------------ */
document.querySelectorAll(".static-cta button, button.scroll").forEach((btn) => {
  btn.addEventListener("click", () => {
    const target = document.querySelector(".options-bracket");
    if (target) window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
  });
});

/* ------------------------------------------------------------------
   DOMContentLoaded
------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", () => {

  /* ── Countdown timer (30 min) ─────────────────────────────────── */
  const deadline = Date.now() + 30 * 60 * 1000;

  const timerInterval = setInterval(() => {
    const remaining = deadline - Date.now();
    if (remaining <= 0) {
      clearInterval(timerInterval);
      setTimerDisplay("00", "00");
      return;
    }
    const mins = Math.floor((remaining / 60000) % 60);
    const secs = Math.floor((remaining / 1000) % 60);
    setTimerDisplay(String(mins).padStart(2, "0"), String(secs).padStart(2, "0"));
  }, 1000);

  function setTimerDisplay(mins, secs) {
    const mEl = document.querySelector(".countdown-timer .minutes");
    const sEl = document.querySelector(".countdown-timer .seconds");
    if (mEl) mEl.textContent = mins;
    if (sEl) sEl.textContent = secs;
  }

  /* ── Hide save-var1 spans on load ─────────────────────────────── */
  document.querySelectorAll(".save-var1").forEach((el) => (el.style.display = "none"));

  /* ── Sync loop-widget prices with active size on load ─────────── */
  syncPricesFromActiveVariant();
  setTimeout(syncPricesFromActiveVariant, 1500); // retry after loop widget renders

  /* ── Loop widget: purchase-option radio toggle ────────────────── */
  document.querySelectorAll('input[name="purchase-option"]').forEach((radio) => {
    radio.addEventListener("change", (e) => {
      document.querySelectorAll(".loop-widget-purchase-option").forEach((opt) =>
        opt.classList.remove("loop-widget-purchase-option-selected")
      );

      const selector =
        e.target.id === "onetime-purchase-radio"
          ? ".loop-widget-purchase-option-onetime"
          : "#loop-widget-purchase-option-id-091440bb412697c5c97504cf99d91f4cfaf82095";

      document.querySelector(selector)?.classList.add("loop-widget-purchase-option-selected");
    });
  });

  /* ── Loop widget container: sub ↔ one-time price display swap ─── */
  document.querySelector(".loop-widget-container")?.addEventListener("click", () => {
    const label = getSelectedPurchaseLabel();
    togglePriceDisplay(label === "One-time purchase");
    changeSaveDesc();
  });

  /* ── Size selector (custom-selectbutton) click ────────────────── */
  document.querySelector(".custom-selectbutton")?.addEventListener("click", () => {
    const flatPrice = document.querySelector(".is-active .pricehidden-flatprice");
    const subPrice  = document.querySelector(".is-active .pricehidden-subprice");
    const subsWidget = document.querySelector(
      ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price"
    );
    const otWidget = document.querySelector(
      ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
    );

    if (flatPrice && subPrice) {
      if (subsWidget) subsWidget.innerHTML = subPrice.value;
      if (otWidget)   otWidget.innerHTML   = flatPrice.value;
    }

    if (getSelectedPurchaseLabel() !== "One-time purchase") changeSaveDesc();

    /* Size-based carousel sync (checkout-bb-sherri only) */
    if (window.checkoutBundleVars?.requestPath === "/pages/checkout-bb-sherri") {
      const selectedBroth  = document.querySelector(".selected-broth");
      const activeSubprice = document.querySelector(".is-active .sizeselector-subprice");
      if (
        selectedBroth?.getAttribute("data-size-based-image") === "true" &&
        activeSubprice
      ) {
        const idx     = activeSubprice.getAttribute("data-id");
        const splideEl = document.querySelector(".product__media-slider .x-splide");
        if (splideEl?.splide) splideEl.splide.go(idx - 1);
      }
    }
  });

  /* ── Ingredients / nutrition modal ───────────────────────────── */
  const modal = document.getElementById("ingredientsModal");
  if (modal) {
    const modalImg = modal.querySelector(".modal-img");
    const closeBtn = modal.querySelector(".btn-close");
    const dialog   = modal.querySelector(".modal-dialog");

    document.querySelectorAll(".modalTrigger").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const src = btn.getAttribute("data-bs-target");
        if (src) modalImg.src = src;
        modal.classList.add("show");
        modal.style.display = "block";
      });
    });

    const closeModal = () => {
      modal.classList.remove("show");
      modal.style.display = "none";
      modalImg.src = "";
    };

    closeBtn?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (!dialog.contains(e.target)) closeModal();
    });
  }

  /* ── Default size option click (e.g. "4 Boxes") ──────────────── */
  const defaultValue = window.checkoutBundleVars?.defaultValue;
  const defaultSpan  = document.querySelector(`.span-wrap[data-value='${defaultValue}']`);
  if (defaultSpan) defaultSpan.click();

  /* ──────────────────────────────────────────────────────────────
     FLAVOR-PRODUCT + PACK-SIZE SELECTORS
     Only active when has_flavor_product_blocks is true.
  ────────────────────────────────────────────────────────────── */
  if (window.checkoutBundleVars?.hasFlavourProducts) {
    initFlavourProductSelectors();
  }
});

/* ------------------------------------------------------------------
   initFlavourProductSelectors
   Reads variant data from the inline JSON script tag, builds pack
   panels in JS (so there is zero chance of CSS showing hidden panels),
   and wires up all interactions.
------------------------------------------------------------------ */
let _fpSelectorsInitialised = false;

function initFlavourProductSelectors() {
  if (_fpSelectorsInitialised) return;
  _fpSelectorsInitialised = true;

  /* ── Parse flavor/variant data from Liquid-rendered JSON ─────── */
  const dataEl = document.getElementById("fp-variants-data");
  if (!dataEl) return;

  let fpData;
  try { fpData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const flavors    = fpData.flavors || [];
  const container  = document.getElementById("fp-pack-panels-container");
  if (!container || !flavors.length) return;

  /* ── Build and inject panel for a given flavor key ───────────── */
  function buildPanel(flavorKey) {
    const key = String(flavorKey);
    const flavor = flavors.find((f) => String(f.key) === key);
    if (!flavor) {
      console.warn("[fp] buildPanel: no flavor found for key:", key, "available:", flavors.map(f => f.key));
      return;
    }

    const showFlat = getSelectedPurchaseLabel() === "One-time purchase";

    let pillsHtml = flavor.variants.map((v, i) => {
      const badge =
        v.name === "4 Boxes" ? '<span class="box-verb most-popular">Most Popular</span>' :
        v.name === "6 Boxes" ? '<span class="box-verb max-saving">Max Savings</span>'   :
        v.name === "2 Boxes" ? '<span class="box-verb starter">Starter</span>'          : "";

      return `<div class="fp-pack-option${i === 0 ? " is-active" : ""}"
                data-variant-id="${v.id}"
                data-flavor="${flavorKey}"
                data-flat-price="${v.flatPrice}"
                data-sub-price="${v.subPrice}"
                data-selling-plan="${v.sellingPlan || ""}">
        ${badge}
        <span class="fp-pack-name">${v.name}</span>
        ${v.packets ? `<span class="fp-pack-count">${v.packets} packets</span>` : ""}
        <span class="fp-pack-price">
          <span class="fp-price-sub"${showFlat ? ' style="display:none"' : ""}>${v.subPerPkt}</span>
          <span class="fp-price-flat"${showFlat ? "" : ' style="display:none"'}>${v.flatPerPkt}</span>
        </span>
        <input type="hidden" class="pricehidden-flatprice" value="${v.flatPrice}">
        <input type="hidden" class="pricehidden-subprice"  value="${v.subPrice}">
      </div>`;
    }).join("");

    container.innerHTML = `
      <p class="fp-pack-label product__option-label"><span>Select </span>Pack Size</p>
      <div class="fp-pack-options" role="group" aria-label="Select Pack Size">${pillsHtml}</div>`;

    /* Attach pill click listeners to the freshly built panel */
    container.querySelector(".fp-pack-options").addEventListener("click", (e) => {
      const pill = e.target.closest(".fp-pack-option");
      if (!pill) return;
      container.querySelectorAll(".fp-pack-option").forEach((p) => p.classList.remove("is-active"));
      pill.classList.add("is-active");
      window.activeProductVariantId = pill.dataset.variantId;
      syncLoopWidgetFromPackOption(pill);
      /* Update price display for the clicked variant */
      const v = flavor.variants.find((vv) => String(vv.id) === String(pill.dataset.variantId));
      if (v) updatePriceDisplay(v);
    });

    /* Sync variant + loop widget from first pill */
    const firstPill = container.querySelector(".fp-pack-option.is-active");
    if (firstPill) {
      window.activeProductVariantId = firstPill.dataset.variantId;
      syncLoopWidgetFromPackOption(firstPill);
    }

    /* Update compare/sale/cta price display for this flavor's first variant */
    updatePriceDisplay(flavor.variants[0]);
  }

  /* ── Flavor radio → rebuild panel + swap carousel ────────────── */
  document.querySelectorAll('input[name="fp-flavor"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      buildPanel(radio.value);
      swapFlavorCarousel(radio.value);
    });
  });

  /* ── Render initial panel for the checked flavor ─────────────── */
  const checkedFlavor = document.querySelector('input[name="fp-flavor"]:checked');
  if (checkedFlavor) {
    buildPanel(checkedFlavor.value);
    swapFlavorCarousel(checkedFlavor.value);
  }
}

/**
 * Swap the Splide product carousel slides to show images
 * for the given flavor key. Reads image URLs from the hidden
 * #fp-image-data element written by Liquid.
 *
 * Strategy: store the original slides HTML per flavor in a cache
 * so we never rebuild from scratch more than once. Replace the
 * splide__list innerHTML, then use the Splide instance's internal
 * mount flow to re-render (destroy + re-mount if available,
 * otherwise plain DOM replace and go-to-0).
 * @param {string} flavorKey
 */
const _fpCarouselCache = {};

function swapFlavorCarousel(flavorKey) {
  const imageData = document.getElementById("fp-image-data");
  if (!imageData) return;

  const flavorData = imageData.querySelector(`[data-fp-flavor="${flavorKey}"]`);
  if (!flavorData) return;

  const count     = parseInt(flavorData.getAttribute("data-count") || "0", 10);
  const sectionId = imageData.getAttribute("data-section-id");
  const list      = document.getElementById(`media_product-${sectionId}`);
  const splideEl  = document.getElementById(`x-product-${sectionId}`);

  if (!list || count === 0) return;

  /* Build slides HTML (cached per flavor) */
  if (!_fpCarouselCache[flavorKey]) {
    let html = "";
    for (let i = 0; i < count; i++) {
      const src = flavorData.getAttribute(`data-src-${i}`);
      const alt = flavorData.getAttribute(`data-alt-${i}`) || "";
      if (!src) continue;
      html += `<div class="splide__slide x-splide-slide" data-index="${i}"${i === 0 ? ' data-selected' : ''}>
        <div class="media media--image" style="padding-bottom:100%;position:relative;overflow:hidden;">
          <img src="${src}" alt="${alt}" loading="${i === 0 ? 'eager' : 'lazy'}"
               style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"
               width="750" height="750">
        </div>
      </div>`;
    }
    _fpCarouselCache[flavorKey] = html;
  }

  /* Replace slide DOM */
  list.innerHTML = _fpCarouselCache[flavorKey];

  /* Re-drive Splide */
  const splide = splideEl?.splide;
  if (splide) {
    try {
      /* Tell Splide to re-collect its slides and reset to first */
      splide.refresh();
      splide.go(0);
    } catch (_) {
      /* Splide refresh failed — force destroy + remount */
      try {
        splide.destroy();
        splide.mount();
        splide.go(0);
      } catch (__) { /* give up gracefully — DOM is already updated */ }
    }
  }
}

/**
 * Update the three dynamic price elements based on the selected variant.
 * - #fp-compare-price  : raw variant price (struck-through original)
 * - #fp-sale-price     : price after 25% off + "FREE SHIPPING"
 * - #fp-onetime-cta    : "Buy Once for $X" after 15% off
 * rawPrice is in Shopify cents (integer).
 * @param {{ rawPrice: number }} variant
 */
function updatePriceDisplay(variant) {
  if (!variant?.rawPrice) return;

  const cents       = variant.rawPrice;
  const compareAmt  = cents / 100;
  const sale25Amt   = cents * 0.75 / 100;
  const onetime15   = cents * 0.85 / 100;

  const fmt = (n) => "$" + n.toFixed(2).replace(/\.00$/, "");

  const compareEl  = document.getElementById("fp-compare-price");
  const saleEl     = document.getElementById("fp-sale-price");
  const onetimeEl  = document.getElementById("fp-onetime-cta");

  if (compareEl) compareEl.textContent = fmt(compareAmt);
  if (saleEl)    saleEl.textContent    = fmt(sale25Amt) + " + FREE SHIPPING";
  if (onetimeEl) onetimeEl.textContent = "Buy Once for " + fmt(onetime15);
}

/**
 * Sync the loop-widget price display from a pack-option pill element.
 * Reads data-flat-price / data-sub-price attributes written by Liquid.
 * @param {HTMLElement} pill - the .fp-pack-option element
 */
function syncLoopWidgetFromPackOption(pill) {
  if (!pill) return;
  const flatPrice = pill.dataset.flatPrice;
  const subPrice  = pill.dataset.subPrice;

  const subsWidget = document.querySelector(
    ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price"
  );
  const otWidget = document.querySelector(
    ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
  );

  if (subPrice  && subsWidget) subsWidget.innerHTML = subPrice;
  if (flatPrice && otWidget)   otWidget.innerHTML   = flatPrice;

  /* Also honour the current one-time / sub display toggle */
  const label = getSelectedPurchaseLabel();
  const isFlat = label === "One-time purchase";
  pill.querySelectorAll(".fp-price-sub").forEach((el) =>
    (el.style.display = isFlat ? "none" : "")
  );
  pill.querySelectorAll(".fp-price-flat").forEach((el) =>
    (el.style.display = isFlat ? "" : "none")
  );

  changeSaveDesc();
}

/* ------------------------------------------------------------------
   Add-to-cart: .submit  (one-time OR subscription based on setting)
   Uses getActiveVariantId() so it always reflects the toggled product.
------------------------------------------------------------------ */
document.querySelectorAll(".submit").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const variantId = getActiveVariantId();
    if (!variantId) return;

    const isSubscription =
      window.checkoutBundleVars?.purchaseOptionType === "subscription";

    const subDiscount = window.checkoutBundleVars?.subscriptionDiscount;
    const oneTimeDiscount = window.checkoutBundleVars?.onetimeDiscount;
    const url = isSubscription
      ? buildCartUrl(variantId, { discount: subDiscount })
      : buildCartUrl(variantId, { discount: oneTimeDiscount });
    console.log("[fp] .submit cart url:", url, "variantId:", variantId);
    window.location.href = url;
  });
});

/* ------------------------------------------------------------------
   Add-to-cart: .subsubmit  (subscribe & save)
   Uses getActiveVariantId() so it always reflects the toggled product.
------------------------------------------------------------------ */
document.querySelectorAll(".subsubmit").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const variantId = getActiveVariantId();
    if (!variantId) return;
    // console.log(buildCartUrl(variantId, {
    //   sellingPlan: window.checkoutBundleVars?.sellingPlan,
    //   discount: window.checkoutBundleVars?.subscriptionDiscount,
    // }));   

    const cartUrl = buildCartUrl(variantId, {
      sellingPlan: getActiveSellingPlan(),
      discount: window.checkoutBundleVars?.subscriptionDiscount,
    });
    console.log("[fp] .subsubmit cart url:", cartUrl, "variantId:", variantId);
    window.location.href = cartUrl;
  });
});

/* ------------------------------------------------------------------
   Helpers
------------------------------------------------------------------ */

/**
 * Build a Shopify cart/clear → cart/add → checkout URL.
 * @param {string} variantId
 * @param {{ sellingPlan?: string, discount?: string|null }} opts
 */
function buildCartUrl(variantId, { sellingPlan = null, discount = null } = {}) {
  let addParams = `items[0][id]=${variantId}&items[0][quantity]=1`;
  if (sellingPlan) addParams += `&items[0][selling_plan]=${sellingPlan}`;

  const returnTo = discount
    ? `/checkout?discount=${discount}`
    : `/checkout`;

  const innerReturnTo = encodeURIComponent(`/cart/add?${addParams}&return_to=${returnTo}`);
  return `https://drkellyann.com/cart/clear?return_to=${innerReturnTo}`;
}

/**
 * Toggle flat vs. subscription price-per-packet display across all size options.
 * Also toggles fp-pack-option pill prices when hasFlavourProducts is active.
 * @param {boolean} showFlat – true = one-time, false = subscription
 */
function togglePriceDisplay(showFlat) {
  document.querySelectorAll(".sizeselector-flatprice")
    .forEach((el) => (el.style.display = showFlat ? "block" : "none"));
  document.querySelectorAll(".sizeselector-subprice")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".save .save-flat")
    .forEach((el) => (el.style.display = showFlat ? "block" : "none"));
  document.querySelectorAll(".save .save-sub")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".save-var1")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".newpricetagtest")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));

  /* Flavour-product pack pills */
  if (window.checkoutBundleVars?.hasFlavourProducts) {
    document.querySelectorAll(".fp-pack-option").forEach((pill) => {
      pill.querySelectorAll(".fp-price-flat").forEach((el) =>
        (el.style.display = showFlat ? "" : "none")
      );
      pill.querySelectorAll(".fp-price-sub").forEach((el) =>
        (el.style.display = showFlat ? "none" : "")
      );
    });
  }
}

/**
 * Sync the loop-widget discount badge and description text
 * with the active size option's discount percentage.
 * Only runs when the product is in the target collection.
 */
function changeSaveDesc() {
  if (!window.checkoutBundleVars?.isInTargetCollection) return;

  const badge          = document.querySelector(".loop-widget-purchase-option-discount-badge");
  const activeDiscount = document.querySelector(".is-active .save .save-sub");
  const discountText   =
    activeDiscount?.innerHTML.includes("%") ? activeDiscount.innerHTML : "Save 10%";

  if (badge?.innerHTML.includes("%")) badge.innerHTML = discountText;

  document
    .querySelectorAll(".loop-widget-purchase-option .loop-widget-sp-selector-description")
    .forEach((desc) => {
      if (desc.innerHTML.includes("Save") && desc.innerHTML.includes("%")) {
        desc.innerHTML = desc.innerHTML.replace(/Save \d+%/, discountText);
      }
    });
}

/**
 * Sync loop-widget subscription / one-time price displays
 * with the active size option's hidden price inputs.
 */
function syncPricesFromActiveVariant() {
  const flatPrice  = document.querySelector(".is-active .pricehidden-flatprice");
  const subPrice   = document.querySelector(".is-active .pricehidden-subprice");
  const subsWidget = document.querySelector(
    ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price"
  );
  const otWidget   = document.querySelector(
    ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
  );

  if (flatPrice && subPrice) {
    if (subsWidget) subsWidget.innerHTML = subPrice.value;
    if (otWidget)   otWidget.innerHTML   = flatPrice.value;
  }
}

/**
 * Get the text label of the currently selected loop-widget purchase option.
 * @returns {string}
 */
function getSelectedPurchaseLabel() {
  return (
    document.querySelector(
      ".loop-widget-purchase-option-selected .loop-widget-purchase-option-label"
    )?.innerHTML ?? ""
  );
}